import React from 'react';
import classNames from 'classnames';

import { Card } from './interfaces';
import { Icon } from 'lmc-ui-library';

const SimpleTriageCard: React.FC<Card> = ({
  type = '',
  title = '',
  navigateTo = () => {},
  subTitle = '',
  icon = 'home',
}) => {
  const className: string = classNames('simple-triage-card', type.toString());

  const handleWrapperClick = () => {
    navigateTo(type.toString());
  };

  return (
    <div className={className} onClick={handleWrapperClick}>
      <Icon type={icon} color="var(--color-extra-white)"></Icon>
      <h2 className="simple-triage-card__header">{title}</h2>
      <div className="simple-triage-card__nav">
        <p>{subTitle}</p>
      </div>
    </div>
  );
};

export default SimpleTriageCard;
